/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFeedMill } from '../../models/customer-feed-mill';

export interface SetActiveCustomer$Params {
  customerFeedMillId: number;
  isActive: boolean;
}

export function setActiveCustomer(http: HttpClient, rootUrl: string, params: SetActiveCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFeedMill>> {
  const rb = new RequestBuilder(rootUrl, setActiveCustomer.PATH, 'put');
  if (params) {
    rb.path('customerFeedMillId', params.customerFeedMillId, {});
    rb.path('isActive', params.isActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFeedMill>;
    })
  );
}

setActiveCustomer.PATH = '/api/customer/feedMill/{customerFeedMillId}/setActive={isActive}';
